import React from 'react'

/* doc
---
title: Card Image
name: Card Image
category: React - Bulma
parent: Card
---

A `CardImage` for adding an image to a `Card`. Adds a fullwidth container for a reponsive image.

Should be used with a `Picture` component

See [Bulma Documentation](http://bulma.io/documentation/components/card/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.


```html_example
  <Card>
    <CardImage>
      <Picture src="#" size="3x2" />
    </CardImage>
  </Card>
```
*/
function CardImage(props) {
  const { children, className, ...rest } = props

  const classes = [
    'card-image',
    className || '',
  ]

  return (
    <div {...rest} className={classes.join(' ')}>
      {children}
    </div>
  )
}

export default CardImage
